import { Component, ElementRef, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { Area } from '@app/models/area';
import { RelatorioPublicacao } from '@app/models/relatorio-publicacao';
import { RelatorioService } from '@app/services/relatorio.service';
import { UtilitarioService } from '@app/services/utilitario.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-publicacoes-tipo',
  templateUrl: './publicacoes-tipo.component.html',
})
export class PublicacoesTipoComponent implements OnInit {
  lstRelatorioPublicacao: RelatorioPublicacao[];
  dataPesquisa: string;
  areaId: number;
  buscando = false;
  @Input() tipoPublicacoes: Area;
  titulo = '';
  descricao = '';
  quantidadePublicacoes = 0;

  dataRelatorio: Date;

  constructor(
    private relatorioService: RelatorioService,
    @Inject(ToastrService) public toastr: ToastrService
  ) { }

  ngOnInit() {
    this.areaId = this.tipoPublicacoes.Id;
    this.lstRelatorioPublicacao = [];
    this.dataPesquisa = new Date().toISOString().split('T')[0];
    this.descricao = this.transformarEmTitulo(this.tipoPublicacoes.Descricao);
    this.titulo = `Relatorio de Publicações (${this.descricao})`;
  }

  private transformarEmTitulo(frase: string): string {
    var titulo = frase.toLowerCase().replace(/(?:^|\s)\S/g, (letra) => letra.toLocaleUpperCase());
    return titulo;
  }

  buscarPublicacoes() {
    this.dataRelatorio = new Date();
    this.buscando = true;
    this.relatorioService
      .buscarPublicacoes(this.areaId, this.dataPesquisa)
      .toPromise()
      .then((relatorio) => {
        this.lstRelatorioPublicacao = relatorio;
        this.quantidadePublicacoes = this.lstRelatorioPublicacao.length;
        this.buscando = false;
        if (this.lstRelatorioPublicacao.length === 0) {
          this.toastr.info(`Não foram encontradas publicações do tipo ${this.descricao} para essa data`);
        }
      },
        () => {
          this.buscando = false;
          this.toastr.warning("Realize a pesquisa novamente.")
        });
  }

  @ViewChild('relatorio') relatorio: ElementRef;
  public imprimir() {
    let conteudo = document.getElementById("relatorioPublicacao").innerHTML;
    UtilitarioService.imprimirHTML(conteudo, this.titulo, this.montaImpressaoFiltros());
  }

  private montaImpressaoFiltros(){
    let objetoFiltros = new Map<string, string>();

    adicionaMapValido('Emitido em', this.dataRelatorio.toLocaleString());
    parseDateAdicionaMap('Data Publicações', this.dataPesquisa);

    function parseDateAdicionaMap(tipoData: string, data: string){
      if(data && data.indexOf('-') >= 0){
        let dataPartes = data.split('-');
        let dataMontada = dataPartes[2] + '/' + dataPartes[1] + '/' + dataPartes[0];
        objetoFiltros.set(tipoData, dataMontada);
      }
    }

    function adicionaMapValido(chave: string, valor: any){
      if(valor){
        objetoFiltros.set(chave, valor.toString());
      }
    }

    let stringHtml = '';

    objetoFiltros.forEach((valor, chave) => {
      stringHtml += `<tr><td>${chave}</td><td>${valor}</td></tr>`;
    })
    return stringHtml;
  }
}
